/**
 * Pomocnicze funkcje sejfu w przeglądarce: generator haseł (Web Crypto, bez znaków mylących: 0/O, 1/l/I) i kopiowanie
 * do schowka. Jawny sekret żyje tylko w stanie komponentu i w schowku osoby, nigdy w cache zapytań ani w URL.
 */

const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%^&*-_=+?';
const ALL = LOWER + UPPER + DIGITS + SYMBOLS;

function randomIndex(max: number): number {
  // odrzucanie wartości spoza zakresu: rozkład równomierny bez skrzywienia modulo
  const limit = Math.floor(0x1_0000_0000 / max) * max;
  const buf = new Uint32Array(1);
  for (;;) {
    crypto.getRandomValues(buf);
    const v = buf[0] as number;
    if (v < limit) return v % max;
  }
}

/** Losowe hasło (domyślnie 20 znaków) z co najmniej jedną małą i wielką literą, cyfrą i symbolem. */
export function generatePassword(length = 20): string {
  const pick = (set: string) => set.charAt(randomIndex(set.length));
  const chars = [pick(LOWER), pick(UPPER), pick(DIGITS), pick(SYMBOLS)];
  while (chars.length < Math.max(length, 12)) chars.push(pick(ALL));
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [chars[i], chars[j]] = [chars[j] as string, chars[i] as string];
  }
  return chars.join('');
}

/** Kopia do schowka; false, gdy przeglądarka nie pozwala (brak uprawnień, brak HTTPS). */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** Link z danych (adres panelu, menedżer haseł) tylko gdy http(s) — nigdy `javascript:` ani inne schematy. */
export function safeHref(value: string | null | undefined): string | null {
  if (!value) return null;
  return /^https?:\/\//i.test(value.trim()) ? value.trim() : null;
}

/** „2026-10-12” → „12.10.2026”. */
export function dateText(date: string): string {
  const [y, m, d] = date.split('-');
  return `${d}.${m}.${y}`;
}
